import request from '../api';
import { actionFactory } from './actionUtils';

export const successStart = actionFactory("START_SUCCESS");

export const getRubrics = () => request('panpartner:subscribes.ajax', 'getRubrics');

export const editSubscription  = form =>  request('panpartner:subscribes.ajax', 'editSubscription', form);